'use client'

import { useState, type FC } from 'react'
import { EyeIcon, EyeOffIcon } from 'lucide-react'
import { Label } from 'ui/label'
import { Input } from 'ui/input'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const PasswordField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    const [visible, setVisible] = useState(false)

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <div className='relative'>
                <Input
                    name={field.name}
                    value={String(value ?? '')}
                    type={visible ? 'text' : 'password'}
                    disabled={!!field.disabled}
                    onChange={e => onChange(field.name, e.target.value, field)}
                    required={field.required}
                />
                <button
                    type='button'
                    onClick={() => setVisible(v => !v)}
                    className='absolute right-3 top-1/2 -translate-y-1/2'
                >
                    {visible ? (
                        <EyeOffIcon className='h-4 w-4 text-muted-foreground' />
                    ) : (
                        <EyeIcon className='h-4 w-4 text-muted-foreground' />
                    )}
                </button>
            </div>
        </FieldWrapper>
    )
}

export default PasswordField
